module.exports = __webpack_public_path__ + "29f5ac835e91176c458bd7ec3367c4b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/printOffline.png
// module id = 272
// module chunks = 0